import type { FrontendPHRT } from '@lotushealth/lotushealth_js_sdk/schemas';

/**
 * Query keys for user PHR data.
 */
export const userPhrKeys = {
  all: ['user-phr'] as const,
  byUser: (userId: string) => ['user', userId, 'phr'] as const,
};

/**
 * Canonical identifiers for the six tables surfaced inside `FrontendPHRT`.
 * Single source of truth for `phrTableConfig`, `PhrTableTab`,
 * `PatientHealthRecordsTab`, and the global-search PHR provider.
 */
export const PHR_TABLE_KEYS = [
  'conditions',
  'labs',
  'medications',
  'notes',
  'procedures',
  'vitals',
] as const satisfies ReadonlyArray<keyof FrontendPHRT>;

export type PhrTableKey = (typeof PHR_TABLE_KEYS)[number];

export const PHR_TABLE_LABELS: Record<PhrTableKey, string> = {
  conditions: 'Conditions',
  labs: 'Labs',
  medications: 'Medications',
  notes: 'Notes',
  procedures: 'Procedures',
  vitals: 'Vitals',
};
